import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    root: { position: 'relative' as const },
    cancelButton: {
        marginLeft: 'auto' as const,
        marginRight: '1.5rem'
    },
    userContainer: {
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF',
        padding: '60px 0 '
    },
    userHeaderContainer: { padding: '50px 0px 70px 40px' },
    actionButton: { alignSelf: 'center' },
    apiTitle: {
        fontSize: '2rem',
        color: theme?.app?.clientTheme.colors.primaryColor ||
            '#375073',
        marginRight: '.5rem'
    },
    userLockedIcon: {
        marginLeft: '.75rem',
        paddingTop: '.2rem'
    },
    userTabsContainer: {
        backgroundColor: theme?.app?.applicationColors.enumColors.offWhite ||
            '#F3F3F3',
        padding: '10px 0px'
    },
    indicator: {
        height: '5px',
        top: 0,
        background: theme?.app?.clientTheme.colors.primaryColorLight ||
            '#009BDF'
    },
    tabRoot: {
        border: `1px solid ${theme?.app?.applicationColors.enumColors.offWhite ||
        '#f3f3f3'}`,
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF',
        fontSize: '0.85rem',
        opacity: '1',
        '&:hover': {
            backgroundColor: theme?.app?.clientTheme.colors.buttons.primaryColorLight ||
                '#009BDF',
            color: theme?.app?.applicationColors.enumColors.white ||
                '#FFFFFF'
        },
        '&.Mui-selected': {
            backgroundColor: theme?.app?.clientTheme.colors.buttons.primarySelected ||
                '#0B243C',
            color: theme?.app?.applicationColors.enumColors.white ||
                '#FFFFFF'
        }
    }
});